// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-button{\n  text-align: center;\n}\n.dialog-mini .el-select {\n  width: 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
